import { timestampDTOSchema } from '@tempo-io/common-dto';
import { z } from 'zod';
import { scopeKindSchema } from './enums';
import { signalValueDTOSchema } from './signal-value-dto';

export const signalInstanceDTOSchema = z.object({
  id: z.string(),
  organizationId: z.string(),
  signalType: z.string(),
  value: signalValueDTOSchema,
  scopeKey: z.string(),
  scopeKind: scopeKindSchema,
  evidenceCount: z.number().int().nullable(),
  confidence: z.string().nullable(),
  modelName: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  periodStart: z.string().nullable(),
  periodEnd: z.string().nullable(),
  computedAt: z.string(),
  ...timestampDTOSchema.shape,
});
export type SignalInstanceDTO = z.infer<typeof signalInstanceDTOSchema>;
